import { useQuery } from '@tanstack/react-query';
import dayjs from '~/timeInit';

import LereService from '~/services/LereService';

import { heatmapSurchargeQueryKeys } from './heatmapSurchargeQueryKeys';

export function useGetHeatmapSurchargePdf(offerId?: string, enabled = true, generatedAt?: string) {
  return useQuery({
    queryKey: heatmapSurchargeQueryKeys.pdf(offerId ?? '', generatedAt),
    queryFn: ({ signal }) => LereService.getHurdleHeatmap(offerId, { signal }),
    enabled: enabled && !!offerId,
    retry: false,
    refetchOnWindowFocus: 'always',
    refetchInterval: (query) =>
      query.state.data ? Math.max(30_000, dayjs(query.state.data.expiresAt).diff(dayjs()) - 30_000) : false,
  });
}
